import React from 'react'

export function ChevronRight({size = 14, color = 'currentColor'}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true">
      <path d="m9 6 6 6-6 6" />
    </svg>
  )
}
